import {useContext, useState, useEffect } from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {containsXss} from "../../../utils/security/XssFilter";
import {IAM_SERVER_SERVICE_GROUP} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from './GroupRegisterModal.module.css';
import { InnocodeButton, InnocodeInput, InnocodeDropdown, useDialog } from "@intsoft/innocode-core";


/**
 * 그룹 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const GroupRegisterModal = ({update, selectedServiceId, groupData, selectedGroupId}) => {
    const {closeModal} = useContext(ModalContext);
    const { showDialog } = useDialog();

    const [formData, setFormData] = useState({
        serviceId: selectedServiceId,
        groupName: '',
        groupDescription: '',
        parentGroupId: ''
    });

    useEffect(() => {
        // selectedGroupId가 "0"이 아니면 parentGroupId에 자동 할당
        if (selectedGroupId && selectedGroupId !== "0") {
            setFormData(prev => ({
            ...prev,
            parentGroupId: selectedGroupId
            }));
        }
        // 만약 최상위라면 빈값
        else {
            setFormData(prev => ({
            ...prev,
            parentGroupId: ""
            }));
        }
    }, [selectedGroupId]);

    const parentOptions = (groupData || [])
    .filter(item => item.title !== '미지정' && item.key !== '0')
    .map(item => ({
        value: item.key,
        label: item.title
    }));

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    // 그룹 등록 요청 API
    const handleRegister = () => {
        for (let key in formData) {
            if (key !== 'parentGroupId' && formData[key] === '' && key !== 'groupDescription') {
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "경고",
                    message: "빈 칸을 확인해 주세요.",
                    confirmText: "확인",
                });
                return;
            } else if (containsXss(formData[key])) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "경고",
                    message: "올바른 값을 입력해 주세요.",
                    confirmText: "확인",
                });
                return;
            }
        }

        let newFormData = { ...formData };
        if (selectedGroupId && selectedGroupId !== "0") {
            newFormData.parentGroupId = selectedGroupId;
        }
                
        const params = {
            serviceId: newFormData.serviceId,
            groupName: newFormData.groupName,
            groupDescription: newFormData.groupDescription,
            parentGroupId: newFormData.parentGroupId !== '' ? Number(newFormData.parentGroupId) : 0
        };

        const url = IAM_SERVER_SERVICE_GROUP + "/create";
        axios.post(url, params)
            .then((res) => {
                showDialog({
                    iconType: "check",
                    type: 'info',
                    title: "성공",
                    message: res.data.message,
                    confirmText: "확인",
                    onConfirm: () => {
                        update();
                        closeModal();
                    }
                });
            })
            .catch((e) => {
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "실패",
                    message: e.response.data.resultMessage,
                    confirmText: "확인",
                });
            });
    }


    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>그룹 명</p>
                    <InnocodeInput
                        name="groupName"
                        value={formData.groupName}
                        onChange={handleChange}
                        placeholder="그룹 명"
                    />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>설명</p>
                    <InnocodeInput
                        name="groupDescription"
                        value={formData.groupDescription}
                        onChange={handleChange}
                        placeholder="설명"
                        multiline={true}
                        rows={4}
                    />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>상위 그룹</p>
                    {selectedGroupId !== "0" ? (
                        // 하위 뎁스 추가 상황 → 부모 선택 불가, 고정
                        <InnocodeInput
                            value={parentOptions.find(opt => opt.value === selectedGroupId)?.label || ''}
                            readonly={true}
                            disabled={true}
                            placeholder="상위 그룹"
                        />
                    ) : (
                        // 최상위 추가 상황 → 선택 가능
                        <InnocodeDropdown
                            name="parentGroupId"
                            value={formData.parentGroupId || ''}
                            onChange={(value) => setFormData(prev => ({ ...prev, parentGroupId: value }))}
                            options={[
                                { value: '', label: ':: 상위 그룹 선택 ::' },
                                ...parentOptions
                            ]}
                            placeholder="상위 그룹 선택"
                        />
                    )}
                </li>
            </ul>

            <div className={styles.layer__saveBtnBox}>  
                <InnocodeButton
                    size="lg"
                    designType="primary" 
                    onClick={handleRegister}
                >
                    등록
                </InnocodeButton>
            </div>
        </div>
    )
}